const TableRatingFilter = (rows, columnIds, filterValue) => {
	const val = rows.getValue(columnIds);

	return !isNaN(val) ? val >= filterValue : false;
};

// This is an autoRemove method on the filter function that
TableRatingFilter.autoRemove = (val) => val === undefined || val === null || val === '';

export default TableRatingFilter;
